import p1 from './p1.png';
import p2 from './p2.png';
import p3 from './p3.png';
import p4 from './p4.png';
import p5 from './p5.png';
import p6 from './p6.png';
import p7 from './p7.png';
import p8 from './p8.png';
import p9 from './p9.png';
import p10 from './p10.png';
import phidden from './phidden.png';
import traitsgif from './traitsgif.gif';
import t1 from './t (1).png';
import t2 from './t (2).png';
import t3 from './t (3).png';
import t4 from './t (4).png';
import t5 from './t (5).png';
import t6 from './t (6).png';
import t7 from './t (7).png';
import t8 from './t (8).png';
import t9 from './t (9).png';
import t10 from './t (10).png';
import t11 from './t (11).png';
import t12 from './t (12).png';
import t13 from './t (13).png';
import t14 from './t (14).png';
import t15 from './t (15).png';
import t16 from './t (16).png';
import t17 from './t (17).png';
import t18 from './t (18).png';
import t19 from './t (19).png';
import t20 from './t (20).png';
import t21 from './t (21).png';
import t22 from './t (22).png';
import t23 from './t (23).png';
import t24 from './t (24).png';
import t25 from './t (25).png';
import t26 from './t (26).png';
import t27 from './t (27).png';
import t28 from './t (28).png';
import t29 from './t (29).png';
import t30 from './t (30).png';
import t31 from './t (31).png';
import t32 from './t (32).png';
import t33 from './t (33).png';
import t34 from './t (34).png';
import t35 from './t (35).png';
import t36 from './t (36).png';
import t37 from './t (37).png';
import t38 from './t (38).png';
import rm1 from './rm1.png';
import rm2 from './rm2.png';
import rm3 from './rm3.png';
import rm4 from './rm4.png';
import tt from './twitter.svg';
import gh from './github.svg';
import ln from './linkedin.svg';
import op from './opensea.png';
import oplogo from './opensealogo.png';
import pl from './polygon.png';



export default {
   p1,
   p2,
   p3,
   p4,
   p5,
   p6,
   p7,
   p8,
   p9,
   p10,
   phidden,
   traitsgif,
   t1,
   t2,
   t3,
   t4,
   t5,
   t6,
   t7,
   t8,
   t9,
   t10,
   t11,
   t12,
   t13,
   t14,
   t15,
   t16,
   t17,
   t18,
   t19,
   t20,
   t21,
   t22,
   t23,
   t24,
   t25,
   t26,
   t27,
   t28,
   t29,
   t30,
   t31,
   t32,
   t33,
   t34,
   t35,
   t36,
   t37,
   t38,
   rm1,
   rm2,
   rm3,
   rm4,
   tt,
   gh,
   ln,
   op,
   oplogo,
   pl,
 };